import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import TestCard from "./TestCard";
import Tabs from "./Tabs";
import "./PaperListing.css";
import { ClipLoader } from "react-spinners";
import {
  buildListingSearchWithTab,
  readListingTab,
} from "../../../../../custom_utilities/dashboardBannerNavigation";

export default function PyqListing() {
  //  SAFE SELECTORS
  // const pyqYearPaperList = useSelector(
  //   (state) => state.examSlice.pyqYearPaperList || []
  // );
  const selectedPyqYear = useSelector(
    (state) => state.examSlice.selectedPyqYear
  );
const aitsList = useSelector((state) => state.aitsTests.list);
const aitsTabs = useSelector((state) => state.aitsTests.tabs);
const isLoading=useSelector((state)=>state.aitsTests.loading);


  const history = useHistory();
  const location = useLocation();
  const tabs = ["All Tests", "Completed"];

  const [activeTab, setActiveTab] = useState(() => {
    const requested = readListingTab(window.location.search);
    return tabs.includes(requested) ? requested : "All Tests";
  });

  useEffect(() => {
    const requested = readListingTab(location.search);
    setActiveTab(requested && tabs.includes(requested) ? requested : "All Tests");
  }, [location.search]);

  const handleTabChange = (tab) => {
    const nextSearch = buildListingSearchWithTab(location.search, tab, tabs[0]);
    setActiveTab(tab);
    if ((location.search || "") === nextSearch) return;
    history.replace({
      pathname: location.pathname,
      search: nextSearch,
      state: location.state,
    });
  };

  // const list =
  //   selectedPyqYear && pyqYearPaperList.length
  //     ? pyqYearPaperList
  //         .filter(
  //           (g) => String(g.target_year) === String(selectedPyqYear)
  //         )
  //         .flatMap((g) => g.data || [])
  //     : [];
const list =
  selectedPyqYear
    ? aitsList.filter(
        (test) => String(test.year) === String(selectedPyqYear)
      )
    : [];


  const filteredTests =
    activeTab === "All Tests"
      ? list
      : list.filter((test) => test.tab_name === activeTab);

      

  return (
    <div className="paperListingWrapper">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={handleTabChange}
      />

      <div className="paperListingContent">
        {isLoading ? (
          <div className="paperListingContent__loader">
            <ClipLoader size={40} color="#C61C26" />
          </div>
        ) : filteredTests.length > 0 ? (
          filteredTests.map((test) => (
            <TestCard
              key={test.paper_id}
              test={test}
              isPyq
            />
          ))
        ) : (
          <p className="no_tests_text">No tests found.</p>
        )}
      </div>
    </div>
  );
}
